import React from "react";
import { ShowConfirm } from "../../../../helper/Alert";
import { IChangePayload } from "../../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { onChangeReminder } from "../../../../appRedux/actions/Reminder";
import { Link } from "react-router-dom";
import FetchImage from "../../../FetchData/FetchImage";
import moment from "moment";
import "moment/locale/fa";
import faMessage from "../../../../lngProvider/locales/fa_IR.json";
import enMessage from "../../../../lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";

const ToDoItem = ({ todo, done, pageIndexReset }: any) => {
  const dispatch = useDispatch();
  const { locale } = useSelector((setting: any) => setting.settings);
  function onChangeReminderStatus(id: number) {
    const LocaleMessages =
      localStorage.getItem("language") === "fa-IR" ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    ShowConfirm(
      todo.notifyText,
      // `با انتقال رویداد به فهرست ${done ? 'موارد مانده' : 'مواردانجام شده'} موافق هستید ؟`,
      `${messages["messages.withMoveTheEventToThe"]} ${
        done ? messages["messages.remainList"] : messages["messages.doneList"]
      } ${messages["messages.agreeOn"]}`,
      messages["messages.yes"],
      messages["messages.no"],
      () => {
        let params: IChangePayload = {
          notifyId: id,
          isFinal: !done,
        };
        pageIndexReset();
        dispatch(onChangeReminder(params));
      }
    );
  }

  function timing(createTime: any, fireTime: any, strFireDate: any) {
    if (!createTime || !fireTime) return "";
    let preTimeEvent = "زمان رویداد." + ": ";
    var tempFireDate = strFireDate;
    if (locale.locale === "fa") {
      moment.locale("fa");
    } else {
      preTimeEvent = "Event Time" + ": ";
      tempFireDate = fireTime;
    }
    var fireDate_temp = new Date(fireTime) as any;

    let now = new Date() as any;
    if (now > fireDate_temp) {
      let difference = moment(new Date(createTime)).fromNow() as any;

      return preTimeEvent + difference;
    }
    return preTimeEvent + ": " + tempFireDate;
  }

  return (
    <li className="gx-media gx-mb-4">
      <span onClick={() => onChangeReminderStatus(todo.notifyId)}>
        {done ? (
          <i className="icon icon-check-square-o gx-fs-xl"></i>
        ) : (
          <i className="icon icon-uncheck-squire-o gx-fs-xl"></i>
        )}
      </span>
      <div className="gx-user-thumb gx-mr-3">
        <FetchImage
          src={`contactPicture/getContactPicture?id=${todo.employeeIdCreator}`}
          className="gx-rounded-circle gx-size-30 gx-ml-3"
        />
      </div>
      <div className="gx-media-body">
        <div className="gx-flex-row gx-justify-content-between gx-align-items-center">
          <h5 className="gx-text-capitalize gx-user-name gx-mb-0">
            <span className="gx-link">{todo.employeeCreatorName}</span>
          </h5>
        </div>
        <p className="gx-fs-sm gx-m-0">{todo.notifyText}</p>
        <span className="gx-meta-date gx-ml-4">
          <small>
            {timing(todo.creatorDateTime, todo.fireDate, todo.strFireDate)}
          </small>
        </span>
        {/* <span className="gx-meta-date gx-ml-4"><small>{todo.fireDate} </small></span> */}
        {todo.letterId && (
          <Link
            to={`/team-work/instance-details?letterCode=${todo.letterCode}&folder=Inbox-0&isDraft=false`}
          >
            <span
              style={{ direction: "ltr" }}
              className={` gx-font-weight-bold`}
            >
              <span className="gx-text-primary">[</span> رجوع به نامه{" "}
              <span className="gx-text-primary">] </span>
            </span>
          </Link>
        )}
      </div>
    </li>
  );
};

export default ToDoItem;
